import { TYPES } from '../../common/constants';
import * as client from '../../services/client';
import { startPRLoading, stopPRLoading } from './loader';

export const storeKeyContacts = payload => ({
    type:TYPES.FETCH_KEY_CONTACTS_DONE,
    payload
})
export const clearKeyContacts = () => ({
    type:TYPES.CLEAR_KEY_CONTACTS_DONE,
})
export const fetchKeyContacts = (propertyId) => dispatch => {
    dispatch(startPRLoading())
    return client.fetchKeyContacts(propertyId)
    .then(
      response => {
        if(response.ok || response.status === 200){
          response.json().then(responsejson => {  
             dispatch(storeKeyContacts(responsejson));
             dispatch(stopPRLoading())
          })
        } else {
            dispatch(storeKeyContacts([]));
            dispatch(stopPRLoading())
        }
    }).catch(() => {
        dispatch(storeKeyContacts([]));
        dispatch(stopPRLoading())
    })
}